import RbHeaderProductCarousel from '../product-carousel/product-carousel.vue'
import RbEditorialWall from '../editorial-wall/editorial-wall.vue'
export default {
  name: 'rb-header-dynamic-menu-renderer',
  props: {
    menuId: {
      type: String,
      default: '',
    },
    onBestSellerCarouselRender: {
      type: Function,
      default: (isBestSellerCarouselVisible = false) => {
        return isBestSellerCarouselVisible
      },
    },
    onEditorialWallRender: {
      type: Function,
      default: (isEditorialWallVisible = false) => {
        return isEditorialWallVisible
      },
    },
  },
  render(createElement) {
    if (!this.$slots.default) {
      this.onBestSellerCarouselRender(false)
      this.onEditorialWallRender(false)
      return
    }

    const filteredSlots = this.$slots.default?.filter((slot) => !!slot.tag)
    if (!filteredSlots) {
      this.onBestSellerCarouselRender(false)
      this.onEditorialWallRender(false)
      return
    }

    const menuIdSlot = filteredSlots.find((slot) => {
      if (!slot?.data?.attrs) {
        this.onBestSellerCarouselRender(false)
        this.onEditorialWallRender(false)
        return
      }

      const slotMenuId = Object.getOwnPropertyDescriptor(slot.data.attrs, 'data-menu-id')
      return slotMenuId?.value === this.menuId
    })

    if (!menuIdSlot) {
      this.onBestSellerCarouselRender(false)
      this.onEditorialWallRender(false)
      return
    }

    const isBestSellersCarouselPresent = menuIdSlot?.children?.some((child) => {
      return child?.componentOptions?.tag === RbHeaderProductCarousel.name
    })
    this.onBestSellerCarouselRender(!!isBestSellersCarouselPresent)

    const isEditorialWallPresent = menuIdSlot?.children?.some((child) => {
      return child?.componentOptions?.tag === RbEditorialWall.name
    })
    this.onEditorialWallRender(!!isEditorialWallPresent)

    return createElement('div', null, [menuIdSlot])
  },
}
